<template>
  <div v-title :data-title="$route.name">
    <el-card>
      <div class="flex flex_left LH_input">
        <span class="mr_5 text_bold font_14">Submission Date</span>
        <el-date-picker
          :clearable="false"
          v-model="datetime"
          type="daterange"
          unlink-panels
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
          range-separator="To"
          start-placeholder="Start Date"
          end-placeholder="End Date"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <span class="ml_10 mr_5 text_bold font_14">Phone</span>
        <el-input class="mr_10" style="width: 160px" v-model="Phone"></el-input>
        <el-button @click="Search()">Search</el-button>
        <div class="ml_10">
          <!-- <el-button
            @click="DownloadExcel()"
            style="width: 100px"
            type="primary"
            >Export</el-button
          > -->
          <!-- <download-excel
            :data="tableData"
            :fields="json_fields"
            type="csv"
            worksheet="My Worksheet"
            :name="FileName"
          >
            
          </download-excel> -->
        </div>
      </div>
      <el-table
        border
        :header-cell-style="{
          background: '#1484D6',
          color: '#fff',
          padding: ' 5px 0',
        }"
        max-height="700px"
        :data="tableData"
        v-loading="loading"
        element-loading-text="Loading..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-table-column
          label="Enquiry ID"
          prop="OrderId"
          width="100px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="Submission Date"
          prop="SubmitTime"
          width="150px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="Name"
          prop="FirstName"
          width="150px"
          align="center"
        ></el-table-column>
        <!-- <el-table-column
          label="Last Name"
          prop="LastName"
          width="150px"
          align="center"
        ></el-table-column> -->
        <el-table-column
          label="Phone"
          prop="PhoneNumber"
          width="150px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="Email"
          prop="Email"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          label="Address"
          prop="Address"
          width="300px"
          align="center"
        ></el-table-column>
        <el-table-column
          width="150px"
          label="Enquiry Type"
          prop="Intention"
          align="center"
        ></el-table-column>
        <el-table-column
          width="300px"
          label="Interest In"
          prop="Message"
          align="center"
        ></el-table-column>
        <el-table-column label="Action" prop="" width="" align="center">
          <template slot-scope="scope">
            <div class="underline pointer color_red">
              <span
                v-if="scope.row.IsDelete === 0"
                @click="VoidRecoverOrder(scope.row, 1)"
                >Void</span
              >
              <span
                v-if="scope.row.IsDelete === 1"
                @click="VoidRecoverOrder(scope.row, 0)"
                >Recover</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="mt_15 flex text_left">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[100, 200, 300]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { get } from "../assets/api/api";
import { timeChange } from "../assets/api/Datetimeformat";
import { export_json_to_excel } from "../assets/api/generateExcel";
import { OrderAdminList, VoidRecoverOrder } from "../assets/api/request";

export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "Last 7 Days",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 30 Days",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 90 Days",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 6 Months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Year",
            onClick(picker) {
              const end = new Date();
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              const start = new Date();
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      datetime: [],
      Phone: "",
      tableData: [],
      json_fields: {
        OrderID: "OrderId",
        "Submit Time": "SubmitTime",
        "First Name": "FirstName",
        "Last Name": "FirstName",
        "Phone Number": "PhoneNumber",
        Email: "Email",
        Address: "Address",
        Intention: "Intention",
        Message: "Message",
      },
      FileName: "",
      loading: false,
      pageIndex: 1,
      pageSize: 100,
      total: 0,
    };
  },
  mounted() {
    document.getElementsByClassName(
      "el-pagination__jump"
    )[0].childNodes[0].nodeValue = "Go to page";
    const end = new Date();
    const start = new Date();
    start.setMonth(start.getMonth() - 1);
    this.datetime = [timeChange(start), timeChange(end)];
    this.FileName = timeChange(start) + "-" + timeChange(end) + "orders";
    this.getData();
  },
  methods: {
    Search() {
      this.pageIndex = 1;
      this.pageSize = 100;
      this.getData();
    },
    DownloadExcel() {
      let filterVal = [];
      Object.keys(this.tableData[0]).forEach((item) => {
        if (item !== "TotalCount") {
          filterVal.push(item);
        }
      });
      let filename = this.FileName;
      var data = this.formatJson(filterVal, this.tableData);
      export_json_to_excel({
        header: filterVal,
        data,
        filename,
      });
    },
    formatJson(filterVal, tableData) {
      return tableData.map((v) => {
        return filterVal.map((j) => {
          return v[j];
        });
      });
    },
    getData() {
      this.loading = true;
      get(
        OrderAdminList +
          "?StartTime=" +
          this.datetime[0] +
          "&EndTime=" +
          this.datetime[1] +
          "&Phone=" +
          this.Phone +
          "&PageIndex=" +
          this.pageIndex +
          "&PageSize=" +
          this.pageSize
      )
        .then((res) => {
          if (res.data.code === 200) {
            this.tableData = res.data.data;
          } else {
            this.tableData = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    VoidRecoverOrder(row, type) {
      this.$confirm("Are you sure to continue?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          get(
            VoidRecoverOrder + "?OrderId=" + row.OrderId + "&IsDelete=" + type
          ).then((res) => {
            if (res.data.code === 200) {
              this.$message.success("Successful.");
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .finally(() => {
          this.getData();
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getData();
    },
  },
};
</script>

<style></style>
